// extracted by mini-css-extract-plugin
module.exports = {"container":"legality_container__TrNaQ","legalities":"legality_legalities__nqeAV","label":"legality_label__zQ9pJ"};